module.exports = __webpack_public_path__ + "static/media/msg.edf4241f.gif";